import { defineComponent, ref, openBlock, createElementBlock, createBlock, unref, withCtx, createVNode, createElementVNode, createCommentVNode, createTextVNode } from "vue";
import { CdrBanner, IconErrorFill, CdrButton, IconXLg, CdrInput, CdrLink, IconMyLocation } from "@rei/cedar";
const _hoisted_1 = {
  class: "zip-editor"
};
const _hoisted_2 = {
  class: "zip-editor__buttons"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxChangeShippingForm",
  props: {
    initialZip: {},
    geolocationError: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close", "updateAddress", "updateGeolocation", "clearGeolocationError"],
  setup(__props) {
    const props = __props;
    const newAddress = ref(props.initialZip);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.geolocationError ? (openBlock(), createBlock(unref(CdrBanner), {
        key: 0,
        type: "error",
        role: "alert",
        class: "zip-editor__error-banner"
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconErrorFill))]),
        "icon-right": withCtx(() => [createVNode(unref(CdrButton), {
          "icon-only": true,
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("clearGeolocationError"))
        }, {
          default: withCtx(() => [createVNode(unref(IconXLg), {
            "inherit-color": ""
          })]),
          _: 1
        })]),
        default: withCtx(() => [_cache[5] || (_cache[5] = createElementVNode("div", {
          class: "zip-editor__error-text"
        }, " We were unable to retrieve your location. Please try again later, or enter your ZIP manually. ", -1))]),
        _: 1
      })) : createCommentVNode("", true), createVNode(unref(CdrInput), {
        modelValue: newAddress.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => newAddress.value = $event),
        error: _ctx.invalid,
        label: "Zip code",
        required: ""
      }, {
        info: withCtx(() => [createVNode(unref(CdrLink), {
          tag: "button",
          type: "button",
          onClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("updateAddress", {
            geo: true
          }))
        }, {
          default: withCtx(() => [createVNode(unref(IconMyLocation), {
            "inherit-color": ""
          }), _cache[6] || (_cache[6] = createTextVNode(" Use my location "))]),
          _: 1
        })]),
        "helper-text-bottom": withCtx(() => _cache[7] || (_cache[7] = [createTextVNode(" Ex. 90012 ")])),
        error: withCtx(() => _cache[8] || (_cache[8] = [createTextVNode(" Enter a 5 digit U.S. Zip Code ")])),
        _: 1
      }, 8, ["modelValue", "error"]), createElementVNode("div", _hoisted_2, [createVNode(unref(CdrButton), {
        "data-ui": "zip-editor-submit",
        type: "submit",
        onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("updateAddress", {
          newAddress: newAddress.value,
          geo: false
        }))
      }, {
        default: withCtx(() => _cache[9] || (_cache[9] = [createTextVNode(" Update ship location ")])),
        _: 1
      }), createVNode(unref(CdrButton), {
        modifier: "secondary",
        "data-ui": "zip-editor-cancel",
        onClick: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("close"))
      }, {
        default: withCtx(() => _cache[10] || (_cache[10] = [createTextVNode(" Cancel ")])),
        _: 1
      })])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxChangeShippingForm2.mjs.map
